<script setup lang="ts">
type Slots = {
  default?(): any;
};

const slots = defineSlots<Slots>();
</script>

<template>
  <div
    v-if="slots.default"
    class="dialog-footer"
  >
    <slot />
  </div>
</template>

<style lang="postcss" scoped>
.dialog-footer {
  @apply py-4 px-6  w-full bottom-0 bg-white z-50;
  @apply mt-auto flex justify-end;
}
</style>
